import React from "react";
//#region types
import { DisplayCommentsProps } from "models/propTypes/timeReportingPropTypes";
import { WintSuperkollAPIModelTimeReporting } from "wint-api-client/dist/types";
//#endregion
//#region components
import { Divider, Grid } from "@mui/material";
import { Skeletons } from "components/common";
import { useTimeReportingService } from "serviceHooks";
//#endregion
import cssExports from "theme/styles/main.module.scss";
import { LocalizationHelperInstance } from "utils/helpers";

const DisplayComments: React.FC<DisplayCommentsProps> = (props) => {
  const timeReportingService = useTimeReportingService();
  const { projectTimeId } = props;

  const [comments, setComments] = React.useState<WintSuperkollAPIModelTimeReporting.ProjectTimeComment[]>([]);
  const [loading, setLoading] = React.useState<boolean>(true);

  React.useEffect(() => {
    if (projectTimeId) {
      timeReportingService
        .getComments(projectTimeId)
        .then((res) => {
          if (res?.length) {
            setComments(res);
          }
        })
        .finally(() => {
          setLoading(false);
        });
    }
  }, [projectTimeId]);

  return loading ? (
    <Skeletons.FormSkeleton></Skeletons.FormSkeleton>
  ) : (
    <Grid>
      {comments
        .sort((c) => c.commentType)
        .reverse()
        .map((c) => (
          <Grid item>
            <Grid>
              <h3>
                {LocalizationHelperInstance.getFormattedMessage(`TimeReporting.CommentType_${c.commentType}`, "")}
              </h3>
              {c.comment}
            </Grid>
            {comments.length === 2 &&
            c.commentType === WintSuperkollAPIModelTimeReporting.ProjectTimeCommentType.External ? (
              <Grid item className={cssExports.commentsDividerContainer}>
                <Divider className={cssExports.dividerGray} />
              </Grid>
            ) : (
              <></>
            )}
          </Grid>
        ))}
    </Grid>
  );
};

export default DisplayComments;
